import React from 'react';
import PageContainer from '../../common/components/Page/PageContainer';
import UsersAccountsContainer from './components/UsersAccounts/UsersAccountsContainer';
import PermissionsCheck from '../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../common/constants/PermissionsEnum';
import './UsersManagement.css';

const UsersManagement = () => (
  <PageContainer pageName="user-accounts">
    <PermissionsCheck appliedToPage={true} permission={PermissionsEnum.VIEW_USERS}>
      <UsersAccountsContainer />
    </PermissionsCheck>
  </PageContainer>
);

export default UsersManagement;
